module.exports = __webpack_public_path__ + "src/assets/img/scroll-bg3.7bc7353d.png";